export const APP_URL = process.env.MIX_APP_URL || '/';
export const AVIS_GARANTIS_ID = process.env.MIX_AVIS_GARANTIS_ID || '';
export const AVIS_GARANTIS_URL = process.env.MIX_AVIS_GARANTIS_URL || '';

export const SINGLE_CMYK = process.env.MIX_SINGLE_CMYK;
export const DOUBLE_CMYK = process.env.MIX_DOUBLE_CMYK;
export const FULL_CUSTOM_CMYK = process.env.MIX_FULL_CUSTOM_CMYK;
export const FULL_CUSTOM_TOP_CMYK = process.env.MIX_FULL_CUSTOM_TOP_CMYK;

export const CMYK_ORDER = process.env.MIX_CMYK_ORDER || '[]';

export const SINGLE_SCREEN_PRINTING = process.env.MIX_SINGLE_SCREEN_PRINTING;
export const DOUBLE_SCREEN_PRINTING = process.env.MIX_DOUBLE_SCREEN_PRINTING;
export const FULL_CUSTOM_SCREEN_PRINTING =
  process.env.MIX_FULL_CUSTOM_SCREEN_PRINTING;

export const SCREEN_PRINTING_ORDER =
  process.env.MIX_SCREEN_PRINTING_ORDER || '[]';
